import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { v4 as uuidv4 } from 'uuid'
import { getAreas, updateArea, deleteArea, addArea, searchGuild} from "../../store/goals/actions"
import SweetAlert from "react-bootstrap-sweetalert"
import Family from "../PlantList/family"
import { getProfile, editProfile } from "../../store/auth/profile/actions"

import {
  Card,
  CardTitle,
  CardText,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Progress,
  Row,
  TabContent,
  TabPane
} from "reactstrap"

import { StorageImage } from '@aws-amplify/ui-react-storage';
import { Storage } from '@aws-amplify/storage'
import { Image} from '@aws-amplify/ui-react'
import { Stage, Layer, Image as KImage, Star, Text, Rect, Group, Circle } from 'react-konva';
import classnames from "classnames"
import { Link } from "react-router-dom"

import { getPlantData, getClimateData, saveClimateData, getCustomClimate } from "../../store/design/actions"
const Spline = require('cubic-spline');

const CIRCLE_COLORS = ["#F1F3EF", "#DDE5D7", "#B9C9AE"]

class PlantCircle extends React.Component {
  state = { image: null }
  componentDidMount() { this.loadImage() }
  componentDidUpdate(prevProps) { if (prevProps.src !== this.props.src) this.loadImage() }
  componentWillUnmount() { if (this.image) this.image.removeEventListener('load', this.handleLoad) }
  loadImage() {
    this.image = new window.Image()
    this.image.crossOrigin = "Anonymous"
    this.image.src = this.props.src
    this.image.addEventListener('load', this.handleLoad)
  }
  handleLoad = () => { this.setState({ image: this.image }) }
  render() {
    const { x, y, color, plant, onSelect, draggable, isSelected, onDragEnd, plantScale } = this.props
    const r = Math.max(14, Math.round((plantScale || 1) * 25))
    const iconSize = Math.min(Math.round(r * 1.35), r * 2 - 4)
    return (
      <Group x={x} y={y} draggable={draggable} onClick={onSelect} onDragEnd={onDragEnd}>
        <Circle radius={r} fill={color || "#DDE5D7"} stroke={isSelected ? "#4a5e44" : "rgba(0,0,0,0.2)"} strokeWidth={isSelected ? 3 : 1} />
        {this.state.image && (
          <KImage image={this.state.image} width={iconSize} height={iconSize} offsetX={iconSize / 2} offsetY={iconSize / 2} />
        )}
        <Text text={plant} y={r + 4} offsetX={50} width={100} align="center" fontSize={10} fill="#333" fontStyle="bold" />
      </Group>
    )
  }
}

// and then we will set it to native image instance when it is loaded
class URLImage extends React.Component {
  state = {
    image: null,
  };
  componentDidMount() {
    this.loadImage();
  }
  componentDidUpdate(oldProps) {
    if (oldProps.src !== this.props.src) {
      this.loadImage();
    }
  }
  componentWillUnmount() {
    this.image.removeEventListener('load', this.handleLoad);
  }

  async loadImage() {
      try {
          // Create an image object
          this.image = new window.Image();
          this.image.crossOrigin = "Anonymous"; // Handle CORS if needed
          this.image.src = this.props.src;

          this.image.addEventListener("load", this.handleLoad);
      } catch (error) {
          console.error("Error loading image from S3:", error);
      }
  }

  handleLoad = () => {
    // after setState react-konva will update canvas and redraw the layer
    // because "image" property is changed
    this.setState({
      image: this.image,
    });
    // if you keep same image object during source updates
    // you will have to update layer manually:
    // this.imageNode.getLayer().batchDraw();
  };
  render() {
    return (
      <KImage
        x={this.props.x}
        y={this.props.y}
        width={this.props.scale*75}
        height={this.props.scale*75}
        onClick={this.props.onSelect}
	      draggable
        image={this.state.image}
        ref={(node) => {
          this.imageNode = node;
        }}
      />
    );
  }
}

const BuildGuild = props => {
  var frame;
  
  const username = JSON.parse(localStorage.getItem("user")).user
  const { onGetClimateData, currArea, onUpdateArea, onSaveGuild, guildResults, area, onSearchGuild,
   plantData, plantDataMap, profile, userClimates, userareas, climateData, history, finishWizard, customplants } = props
  const [customClimate, setCustomClimate] = useState({})
  const [activeTab, setactiveTab] = useState(1)
  const [finishedArea, setFinishedArea] = useState(false)
  const [activeTabProgress, setactiveTabProgress] = useState(1)
  const [tab, setTab] = useState(1) 
  const [errors, setErrors] = useState({})
  const [progressValue, setprogressValue] = useState(5)
  const plantItem = {plant: "", qty: "", unit: ""};
  const [starPlayer, setStarPlayer] = useState()
  const [pendingStarPlayer, setPendingStarPlayer] = useState()
  const [plants, setplants] = useState([])
  const [zone, setZone] = useState()
  const [guildName, setGuildName] = useState()
  const [climate, setClimate] = useState()
  const [layer, setLayer] = useState()
  const [plantFamilies, setPlantFamilies] = useState({})
  const [guildFunction, setGuildFunction] = useState()
  const [userGuildResults, setUserGuildResults] = useState([])
  const [zipcode, setZipcode] = useState("")
  const [coolSeason, setCoolSeason] = useState([])
  const [climateName, setClimateName] = useState()
  const [eventsCreated, setEventsCreated] = useState(false)
  const [areaPlantsCreated, setAreaPlantsCreated] = useState(false)
  const [warmSeason, setWarmSeason] = useState([])
  const [perennialSeason, setPerennialSeason] = useState([])
  const [plantWindows, setPlantWindow] = useState({})
  const [guildPlants, setGuildPlants] = useState([])
  const [customClimateModal, setCustomClimateModal] = useState(false)
  const [searchGuild, setSearchGuild] = useState(false)
  const [dragging, setDragging] = useState(false)
  const [imageX, setImageX] = useState(0)
  const [imageY, setImageY] = useState(0)
  const [showGuild, setShowGuild] = useState(false)
  const [currentShape, setCurrentShape] = useState()
  const dragUrl = useRef()
  const stageRef = useRef()
  const [images, setImages] = useState([])
  const [initiated, setInitiated] = useState()
  const [lastSearchParams, setLastSearchParams] = useState(null)
  const [searching, setSearching] = useState(false)
  const [canvasMode, setCanvasMode] = useState("move")
  const [selectedImageId, setSelectedImageId] = useState(null)
  const [showRefCircle, setShowRefCircle] = useState(false)
  const [savedGuild, setSavedGuild] = useState(null)
  const user = JSON.parse(localStorage.getItem("user")).user;

  var areasSync = []
  var palette = [
     "#FF1800", "#1C7500", "#0943BE", "#F8FE00"
  ]

  useEffect(() => {
    if (profile) {
        const cl = profile.climate || '*'
        const zn = profile.USDAzone || '*'
        setZone(profile.USDAzone || '')
        setClimate(profile.climate || '')
        const params = { guildFunction: 'Star Player', zone: zn, climate: cl, layer: '*' }
        setLastSearchParams(params)
        onSearchGuild(params)
    }
  }, [profile])

  useEffect(() => {
    const { onGetPlantData } = props
    onGetPlantData()
  }, [])

  useEffect(() => {
    const backendResults = (guildResults && guildResults.length > 0) ? guildResults : []
    const params = lastSearchParams
    let merged = [...backendResults]
    if (params && customplants && customplants.length > 0) {
      const fn = params.guildFunction
      const zn = params.zone
      const cl = params.climate
      const ly = params.layer
      const matching = customplants.filter(cp => {
        const fnMatch = fn === '*' || (Array.isArray(cp.guildFunction) && cp.guildFunction.includes(fn))
        const znMatch = zn === '*' || !zn || (cp.USDAMin != null && cp.USDAMax != null && parseInt(zn) >= cp.USDAMin && parseInt(zn) <= cp.USDAMax)
        const clMatch = cl === '*' || !cl || (Array.isArray(cp.climate) && cp.climate.includes(cl))
        const lyMatch = ly === '*' || !ly || (Array.isArray(cp.foodForestLayer) && cp.foodForestLayer.includes(ly))
        return fnMatch && znMatch && clMatch && lyMatch
      }).map(cp => ({
        name: cp.species,
        plant_family: cp.plantFamily,
        guildFunction: cp.guildFunction || [],
        foodForestLayer: cp.foodForestLayer || [],
        climate: cp.climate || [],
        USDAMin: cp.USDAMin,
        USDAMax: cp.USDAMax,
        size: cp.size,
        spacing_between_plants: cp.spacing_between_plants,
        yield_per_plant_ounces: cp.yieldPerPlant,
        cardIconKey: cp.cardIconKey,
        designerIconKey: cp.designerIconKey,
        isCustomPlant: true,
      }))
      merged = [...backendResults, ...matching].sort((a, b) => (a.name > b.name) ? 1 : -1)
    }
    setUserGuildResults(merged)
    setSearching(false)
  }, [guildResults, customplants, lastSearchParams])

  function toggleSearch() {
      setSearchGuild(!searchGuild)
  }

  function generateColorFromPalette() {
      return palette[Math.floor(Math.random() * 4)];
  }

  const plantScales = {
            "tiny": 0.35,
            "small": 0.5,
            "medium": 0.75,
            "large": 1,
            "shrub": 2,
            "small tree": 3,
            "medium tree": 4,
            "large tree": 6
    }

  function addGuildPlant(plant) {
     let guildPlant = Object.assign({}, plant);
     guildPlant["totalHarvest"] = 0
     guildPlant["estHarvest"] = 0;
     let plants = [...guildPlants];
     plants.push(guildPlant);

     // recalc families
     var plantFamilies = {}
     for (var i=0; i<plants.length; i++) {
          plantFamilies[plants[i].plant_family] = "1"
     }
     if (starPlayer) plantFamilies[starPlayer.plant_family] = "1"
     setSearchGuild(false)
     setPlantFamilies(plantFamilies)
     setGuildPlants(plants)
  }

  function setName(name, index) {
     let fplants = [...plants];
     let item = {
         ...fplants[index],
         plant: name
     }
     fplants[index] = item
     setplants(fplants)
  }

  function setUnit(unit, index) {
     let fplants = [...plants];
     let item = {
         ...fplants[index],
         unit: unit
     }
     fplants[index] = item
     setplants(fplants)
  }

  function buildSearch() {
      setUserGuildResults([])
      setGuildFunction() 
      setLayer()
      setSearchGuild(true)
  }

  function buildFunctionSearch(guildfunc) {
      setUserGuildResults([])
      setSearching(true)
      setGuildFunction(guildfunc)
      setLayer()
      const params = { guildFunction: guildfunc, zone: zone || '*', climate: climate || '*', layer: '*' }
      setLastSearchParams(params)
      onSearchGuild(params)
      setSearchGuild(true)
  }

  function buildLayerSearch(layerVal) {
      setUserGuildResults([])
      setSearching(true)
      setGuildFunction()
      setLayer(layerVal)
      const params = { guildFunction: '*', zone: zone || '*', climate: climate || '*', layer: layerVal }
      setLastSearchParams(params)
      onSearchGuild(params)
      setSearchGuild(true)
  }

  function setQuantity(qty, index) {
     let fplants = [...plants];
     let item = {
         ...fplants[index],
         qty: qty
     }
     fplants[index] = item

     setplants(fplants);
  }

  function setZip (zip) {
     setZipcode(zip);
  }

  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab)
      }
    }
  }

   function searchStarPlayer() {
      var cl = climate?climate:'*'
      var zn = zone?zone:'*'
      var ly = layer?layer:'*'
      var fn = 'Star Player'
      var searchGuildParams = {
   guildFunction: fn,
         zone: zn,
   climate: cl,
   layer: ly
      }
      setLastSearchParams(searchGuildParams)
      onSearchGuild(searchGuildParams)
  }

  function selectShape(evt) {
     setCurrentShape(evt.currentTarget)
  }

   function deletePlant() {
     currentShape.destroy()
  }

    function removePlant(pindex) {
        var newGuildPlants = [...guildPlants]
        newGuildPlants.splice(pindex, 1);
        setGuildPlants(newGuildPlants)
  }

  function updateImagePosition(id, x, y) {
      setImages(prev => prev.map(img => img.id === id ? { ...img, x, y } : img))
  }

  function resetWizard() {
      setSavedGuild(null)
      setactiveTabProgress(1)
      setprogressValue(5)
      setStarPlayer(undefined)
      setPendingStarPlayer(undefined)
      setGuildPlants([])
      setGuildName(undefined)
      setImages([])
      setErrors({})
      setPlantFamilies({})
  }


   function finishGuild() {
      var terrors = {
     }
     var failedValidation = false
     if (guildName==undefined || guildName=='') {
         terrors['guildName'] = "Guild Name is required"
         failedValidation = true
     }
     if (failedValidation) {
         setErrors(terrors)
         return
     }
      var finalGuild = {}

      var totals = {}
     for (var i in images) {
          if (totals[images[i].plant]) 
            totals[images[i].plant] += 1
          else 
            totals[images[i].plant] = 1
     }
     for (const plant in totals) {
          for (var j in guildPlants) {
              if (guildPlants[j].name == plant) 
                   guildPlants[j].numPlants = totals[plant]
          }
          if (starPlayer.name == plant)
              starPlayer.numPlants = totals[plant]
     }
     saveGuild()
     //setShowGuild(true)
  }

  const dataURLtoBlob = (dataurl) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  function saveGuild () {
      // Build normalized plant list
      const prepPlant = (p) => {
          const numPerSquareFoot = Math.pow(12 / p["spacing_between_plants"], 2);
          return {
              ...p,
              variety: "",
              totalHarvest: 0,
              harvests: [],
              notes: [],
              guild: guildName,
              estHarvest: p["yield_per_plant_ounces"] * p.numPlants / 16.0,
              spaceUsed: (p.numPlants / numPerSquareFoot).toFixed(2),
              species: p.name,
          };
      };

      const preparedStar = prepPlant({ ...starPlayer });
      const preparedSupports = guildPlants.map(p => prepPlant({ ...p }));
      const allGuildPlants = [preparedStar, ...preparedSupports];

      const dataUrl = stageRef.current.toDataURL();
      const blob = dataURLtoBlob(dataUrl);

      if (onSaveGuild) {
          // Standalone guild — save to Guilds table, no area involved
          const imageKey = `${username}-${guildName}`;
          Storage.put(imageKey, blob, { contentType: "image/png" }).then(() => {
              onSaveGuild({ guildName, starPlayer: preparedStar, guildPlants: preparedSupports, imageKey });
              setSavedGuild({ guildName, starPlayer: preparedStar, guildPlants: preparedSupports });
          });
      } else {
          // Legacy — save directly into the area
          var newPlants = [...currArea.plants, ...allGuildPlants];
          currArea["guilds"][guildName] = allGuildPlants;
          currArea.plants = newPlants;
          const imageKey = `${username}-${currArea.name}-${guildName}`;
          Storage.put(imageKey, blob, { contentType: "image/png" }).then(() => {
              onUpdateArea(currArea);
              finishWizard();
          });
      }
  }

  function submitSearch() {
      var cl = climate?climate:'*'
      var zn = zone?zone:'*'
      var ly = layer?layer:'*'
      var fn = guildFunction?guildFunction:'*'
      var searchGuildParams = {
           guildFunction: fn,
           zone: zn,
           climate: cl,
           layer: ly
      }
      setLastSearchParams(searchGuildParams)
      onSearchGuild(searchGuildParams)
  }

  function toggleTabProgress(tab) {
    if (activeTabProgress !== tab) {
        setprogressValue(20*(tab-1))
        setTab(tab)
        setactiveTabProgress(tab)
    }
  }

  if (savedGuild) {
      const allPlants = [savedGuild.starPlayer, ...savedGuild.guildPlants]
      const familyCounts = {}
      allPlants.forEach(p => {
          const fam = p.plant_family || "Unknown"
          familyCounts[fam] = (familyCounts[fam] || 0) + 1
      })
      const numFamilies = Object.keys(familyCounts).length
      const penalty = Object.values(familyCounts).reduce((sum, c) => sum + Math.max(0, c - 1), 0)
      const score = numFamilies - penalty
      const getRating = (s) => {
          if (s >= 5) return { label: "Great", color: "#7F8F7B" }
          if (s === 4) return { label: "Good", color: "#8FAA6F" }
          if (s === 3) return { label: "Ok", color: "#FF9900" }
          if (s === 2) return { label: "Fair", color: "#E07B39" }
          return { label: "Poor", color: "#C0392B" }
      }
      const rating = getRating(score)

      return (
          <React.Fragment>
              <Row>
                  <Col lg={12}>
                      <Card>
                          <CardBody style={{ padding: "48px 32px", textAlign: "center" }}>
                              {/* Success mark */}
                              <div style={{ width: 72, height: 72, borderRadius: "50%", backgroundColor: "#7F8F7B", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
                                  <i className="fas fa-check" style={{ color: "#fff", fontSize: "2rem" }} />
                              </div>
                              <h3 style={{ color: "#2e3d2a", marginBottom: 6 }}>Guild Saved!</h3>
                              <p style={{ color: "#6c757d", marginBottom: 36, fontSize: "0.95rem" }}>
                                  Your plant guild has been created and added to your collection.
                              </p>

                              {/* Summary card */}
                              <div style={{ maxWidth: 520, margin: "0 auto 36px", textAlign: "left", border: "1px solid #dde5d7", borderRadius: 8, overflow: "hidden" }}>
                                  {/* Header */}
                                  <div style={{ backgroundColor: "#DDE5D7", padding: "16px 20px", borderBottom: "1px solid #BEC8B6" }}>
                                      <div style={{ fontSize: "1.25rem", fontWeight: 700, color: "#2e3d2a" }}>{savedGuild.guildName}</div>
                                      <div style={{ fontSize: "0.85rem", color: "#4a5e44", marginTop: 4 }}>
                                          <i className="fas fa-star" style={{ color: "#FF9900", marginRight: 6 }} />
                                          Star Player: <strong>{savedGuild.starPlayer.name}</strong>
                                      </div>
                                  </div>
                                  {/* Stats */}
                                  <div style={{ display: "flex", backgroundColor: "#f5f8f3", padding: "14px 20px", gap: 32, borderBottom: "1px solid #eef1eb" }}>
                                      <div style={{ textAlign: "center" }}>
                                          <div style={{ fontSize: "1.6rem", fontWeight: 700, color: "#2e3d2a", lineHeight: 1 }}>{allPlants.length}</div>
                                          <div style={{ fontSize: "0.72rem", color: "#6c757d", marginTop: 4, textTransform: "uppercase", letterSpacing: "0.04em" }}>Plants</div>
                                      </div>
                                      <div style={{ textAlign: "center" }}>
                                          <div style={{ fontSize: "1.6rem", fontWeight: 700, color: rating.color, lineHeight: 1 }}>{score}</div>
                                          <div style={{ fontSize: "0.72rem", color: "#6c757d", marginTop: 4, textTransform: "uppercase", letterSpacing: "0.04em" }}>Diversity Score</div>
                                      </div>
                                      <div style={{ textAlign: "center" }}>
                                          <div style={{ fontSize: "1.1rem", fontWeight: 700, color: rating.color, lineHeight: 1.2 }}>{rating.label}</div>
                                          <div style={{ fontSize: "0.72rem", color: "#6c757d", marginTop: 4, textTransform: "uppercase", letterSpacing: "0.04em" }}>Diversity</div>
                                      </div>
                                      <div style={{ textAlign: "center" }}>
                                          <div style={{ fontSize: "1.6rem", fontWeight: 700, color: "#2e3d2a", lineHeight: 1 }}>{numFamilies}</div>
                                          <div style={{ fontSize: "0.72rem", color: "#6c757d", marginTop: 4, textTransform: "uppercase", letterSpacing: "0.04em" }}>Families</div>
                                      </div>
                                  </div>
                                  {/* Plant list */}
                                  <div style={{ backgroundColor: "#fff" }}>
                                      {allPlants.map((p, i) => (
                                          <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 20px", borderBottom: i < allPlants.length - 1 ? "1px solid #f5f5f5" : "none" }}>
                                              {i === 0
                                                  ? <i className="fas fa-star" style={{ color: "#FF9900", fontSize: "0.7rem", width: 14, flexShrink: 0 }} />
                                                  : <i className="fas fa-leaf" style={{ color: "#BEC8B6", fontSize: "0.7rem", width: 14, flexShrink: 0 }} />
                                              }
                                              <span style={{ fontSize: "0.85rem", fontWeight: i === 0 ? 600 : 400, color: "#2e3d2a", flex: 1 }}>{p.name}</span>
                                              <span style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                                                  {Array.isArray(p.guildFunction) ? p.guildFunction.join(", ") : p.guildFunction}
                                              </span>
                                          </div>
                                      ))}
                                  </div>
                              </div>

                              {/* Next steps */}
                              <p style={{ fontSize: "0.82rem", color: "#6c757d", marginBottom: 16 }}>What would you like to do next?</p>
                              <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
                                  <button type="button" className="btn" style={{ backgroundColor: "#FF9900", borderColor: "#FF9900", color: "#fff" }} onClick={finishWizard}>
                                      <i className="fas fa-seedling" style={{ marginRight: 6 }} />View My Guilds
                                  </button>
                                  <button type="button" className="btn" style={{ backgroundColor: "#fff", borderColor: "#7F8F7B", color: "#4a5e44" }} onClick={finishWizard}>
                                      <i className="fas fa-map-marker-alt" style={{ marginRight: 6 }} />Add to an Area
                                  </button>
                                  <button type="button" className="btn" style={{ backgroundColor: "#fff", borderColor: "#d1d5db", color: "#212529" }} onClick={resetWizard}>
                                      <i className="fas fa-plus" style={{ marginRight: 6 }} />Create Another Guild
                                  </button>
                              </div>
                              <p style={{ fontSize: "0.75rem", color: "#adb5bd", marginTop: 14, marginBottom: 0 }}>
                                  To deploy this guild to a garden area, go to My Guilds and press Deploy to Area.
                              </p>
                          </CardBody>
                      </Card>
                  </Col>
              </Row>
          </React.Fragment>
      )
  }

  return (
    <React.Fragment>
      <style>{`
        .twitter-bs-wizard-nav .nav-link .step-number {
          background-color: #BEC8B6 !important;
          color: #3d4a38 !important;
          border-color: #BEC8B6 !important;
        }
        .twitter-bs-wizard-nav .nav-link.active .step-number {
          background-color: #FF9900 !important;
          color: #fff !important;
          border-color: #FF9900 !important;
        }
        .twitter-bs-wizard-nav .nav-link.active {
          color: #212529 !important;
        }
        .twitter-bs-wizard-nav,
        .twitter-bs-wizard-nav .nav-link,
        .twitter-bs-wizard-nav .nav-link.active {
          background-color: #DDE5D7 !important;
        }
        .twitter-bs-wizard-nav .nav-link.completed .step-number {
          background-color: #7F8F7B !important;
          color: #fff !important;
          border-color: #7F8F7B !important;
        }
        #bar, #bar .progress, #bar > div {
          background-color: #DDE5D7 !important;
        }
      `}</style>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">{currArea.name}</h4>

                    <div id="progrss-wizard" className="twitter-bs-wizard">
                        <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                            {[
                                { n: 1, label: "Choose Star Player" },
                                { n: 2, label: "Add by Function" },
                                { n: 3, label: "Design Your Layers" },
                                { n: 4, label: "Check Diversity" },
                                { n: 5, label: "Draw Your Guild" },
                            ].map(({ n, label }) => (
                                <NavItem key={n}>
                                    <NavLink
                                        className={classnames({
                                            active: activeTabProgress === n,
                                            completed: activeTabProgress > n,
                                        })}
                                        onClick={() => toggleTabProgress(n)}
                                    >
                                        <span className="step-number mr-2">
                                            {activeTabProgress > n ? <i className="fas fa-check" /> : n}
                                        </span>
                                        <span>{label}</span>
                                    </NavLink>
                                </NavItem>
                            ))}
                        </ul>

                        <div id="bar" className="mt-4" style={{ marginBottom: "16px" }}>
                            <div style={{ height: "6px", backgroundColor: "#DDE5D7", borderRadius: 3 }}>
                                <div style={{ height: "100%", width: `${progressValue}%`, backgroundColor: "#7F8F7B", borderRadius: 3, transition: "width 0.4s ease" }} />
                            </div>
                        </div>
                        <TabContent
                            activeTab={activeTabProgress}
                            className="twitter-bs-wizard-tab-content">
                            <TabPane tabId={1}>
                                <div style={{ backgroundColor: "#DDE5D7", borderLeft: "4px solid #7F8F7B", borderRadius: "4px", padding: "14px 18px", marginBottom: "12px", marginTop: "12px" }}>
                                    <div style={{ fontWeight: 600, fontSize: "1rem", marginBottom: "4px", color: "#2e3d2a" }}>Choose your Star Player</div>
                                    <div style={{ fontSize: "0.9rem", color: "#3d4a38", lineHeight: "1.5" }}>
                                        The Star Player is the anchor of your guild — usually the plant with the largest, most desirable harvest, often a fruit tree. Every other plant in the guild is chosen to support it.
                                    </div>
                                </div>

                                {/* Profile indicator */}
                                {(climate || zone) ? (
                                    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "8px 12px", marginBottom: 16, backgroundColor: "#f5f8f3", border: "1px solid #BEC8B6", borderRadius: 4, fontSize: "0.85rem" }}>
                                        <i className="fas fa-check-circle" style={{ color: "#7F8F7B", fontSize: "1rem" }} />
                                        <span>Searching for your location: <strong>{climate || "All climates"}</strong>, Zone <strong>{zone || "any"}</strong></span>
                                    </div>
                                ) : (
                                    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "8px 12px", marginBottom: 16, backgroundColor: "#fff8f0", border: "1px solid #FF9900", borderRadius: 4, fontSize: "0.85rem" }}>
                                        <i className="fas fa-exclamation-triangle" style={{ color: "#FF9900", fontSize: "1rem" }} />
                                        <span>Climate and USDA Zone not set — results will show all regions. Set them in <strong>Profile → Change Address</strong> for better results.</span>
                                    </div>
                                )}

                                {pendingStarPlayer && (
                                    <div style={{ fontSize: "0.85rem", color: "#4a5e44", marginBottom: 8 }}>
                                        Selected: <strong>{pendingStarPlayer.name}</strong> — press Next to confirm
                                    </div>
                                )}

                                <div style={{ width: "100%", height: "400px", overflowX: "hidden", overflowY: "auto" }}>
                                    {userGuildResults.map((plant) => (
                                        <div
                                            key={plant.name}
                                            onClick={() => setPendingStarPlayer(plant)}
                                            style={{
                                                display: "flex", alignItems: "center", gap: "12px",
                                                padding: "10px 12px", marginBottom: "8px", cursor: "pointer",
                                                border: "1px solid #dde5d7", borderRadius: "6px",
                                                backgroundColor: "#fff",
                                                transition: "background-color 0.15s",
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f5f8f3"}
                                            onMouseLeave={e => e.currentTarget.style.backgroundColor = "#fff"}
                                        >
                                            {/* Icon */}
                                            <div style={{ flexShrink: 0, width: 160, height: 100, borderRadius: 4, overflow: "hidden", border: "1px solid #dde5d7", display: "flex", alignItems: "center" }}>
                                                <StorageImage
                                                    alt={plant.name}
                                                    imgKey={plant.cardIconKey ? plant.cardIconKey : "card_icons/" + plant.name.toLowerCase().replace(" ", "_").replace("(", "").replace(")", "").replace(",", "_").replace(" ", "_") + ".png"}
                                                    accessLevel="guest"
                                                    onStorageGetError={(error) => console.error(error)}
                                                    style={{ width: "160px", height: "100px", objectFit: "none", objectPosition: "center", display: "block" }}
                                                />
                                            </div>
                                            {/* Info */}
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                <div style={{ fontWeight: 600, fontSize: "0.95rem", marginBottom: 2 }}>{plant.name}</div>
                                                <div style={{ fontSize: "0.8rem", color: "#6c757d" }}>
                                                    <span style={{ marginRight: 12 }}><b>Layer:</b> {Array.isArray(plant.foodForestLayer) ? plant.foodForestLayer.join(", ") : plant.foodForestLayer}</span>
                                                    <span style={{ marginRight: 12 }}><b>Zone:</b> {plant.USDAMin}–{plant.USDAMax}</span>
                                                    <span><b>Climate:</b> {Array.isArray(plant.climate) ? plant.climate.join(", ") : plant.climate}</span>
                                                </div>
                                                <div style={{ fontSize: "0.8rem", color: "#6c757d", marginTop: 2 }}>
                                                    <b>Functions:</b> {Array.isArray(plant.guildFunction) ? plant.guildFunction.join(", ") : plant.guildFunction}
                                                </div>
                                            </div>
                                            {/* Radio */}
                                            <div style={{ flexShrink: 0, width: 28, height: 28, borderRadius: "50%", border: `2px solid ${pendingStarPlayer?.name === plant.name ? "#FF9900" : "#7F8F7B"}`, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: pendingStarPlayer?.name === plant.name ? "#FFF5E6" : "transparent" }}>
                                                {pendingStarPlayer?.name === plant.name && (
                                                    <div style={{ width: 14, height: 14, borderRadius: "50%", backgroundColor: "#FF9900" }} />
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </TabPane>
                            <TabPane tabId={2}>
                                {(() => {
                                    const fnDefs = [
                                        { key: "Pollinator / Insectary", label: "Pollinator / Insectary", icon: "fa-bug" },
                                        { key: "Food / Fiber",           label: "Food / Fiber",           icon: "fa-leaf" },
                                        { key: "Windbreak / Privacy",    label: "Windbreak / Privacy",    icon: "fa-wind" },
                                        { key: "Dynamic Accumulator",    label: "Dynamic Accumulator",    icon: "fa-recycle" },
                                        { key: "Erosion Control",        label: "Erosion Control",        icon: "fa-water" },
                                        { key: "Nitrogen Fixer",         label: "Nitrogen Fixer",         icon: "fa-flask" },
                                        { key: "Medicinal",              label: "Medicinal",              icon: "fa-mortar-pestle" },
                                        { key: "Pest Repellent",         label: "Pest Repellent",         icon: "fa-shield-alt" },
                                        { key: "Wildlife Benefit",       label: "Wildlife Benefit",       icon: "fa-paw" },
                                        { key: "Wildlife Habitat",       label: "Wildlife Habitat",       icon: "fa-home" },
                                    ];
                                    const filledCount = fnDefs.filter(fn =>
                                        guildPlants.some(p => Array.isArray(p.guildFunction) && p.guildFunction.includes(fn.key))
                                    ).length;
                                    return (
                                        <>
                                            {/* Star player banner */}
                                            {starPlayer && (
                                                <div style={{ backgroundColor: "#212529", color: "#fff", borderRadius: "4px 4px 0 0", padding: "8px 14px", fontSize: "0.85rem", marginTop: 12 }}>
                                                    <i className="fas fa-star" style={{ color: "#FF9900", marginRight: 6 }} />
                                                    Star Player: <strong>{starPlayer.name}</strong>
                                                </div>
                                            )}
                                            {/* Callout description */}
                                            <div style={{ backgroundColor: "#DDE5D7", borderLeft: "4px solid #7F8F7B", borderRadius: starPlayer ? "0 0 4px 4px" : "4px", padding: "14px 18px", marginBottom: 20 }}>
                                                <div style={{ fontWeight: 600, fontSize: "1rem", marginBottom: 4, color: "#2e3d2a" }}>Add plants by function</div>
                                                <div style={{ fontSize: "0.9rem", color: "#3d4a38", lineHeight: 1.5 }}>
                                                    Choose plants to fill each supporting role in your guild. You don't need to fill every function, but aim for at least 4 or 5.
                                                </div>
                                            </div>
                                            {/* Progress indicator */}
                                            <div style={{ backgroundColor: "#fff", border: "1px solid #dde5d7", borderRadius: 4, padding: "8px 14px", marginBottom: 12, display: "flex", alignItems: "center", gap: 12 }}>
                                                <div style={{ flex: 1, height: 6, backgroundColor: "#DDE5D7", borderRadius: 3 }}>
                                                    <div style={{ height: "100%", width: `${Math.round((filledCount / fnDefs.length) * 100)}%`, backgroundColor: filledCount >= 4 ? "#7F8F7B" : "#FF9900", borderRadius: 3, transition: "width 0.3s" }} />
                                                </div>
                                                <div style={{ fontSize: "0.8rem", color: "#6c757d", whiteSpace: "nowrap" }}>
                                                    {filledCount} of {fnDefs.length} functions filled
                                                </div>
                                            </div>
                                            {/* Function rows */}
                                            {fnDefs.map(fn => {
                                                const plantsForFn = guildPlants.filter(p =>
                                                    Array.isArray(p.guildFunction) && p.guildFunction.includes(fn.key)
                                                );
                                                return (
                                                    <div key={fn.key} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 12px", marginBottom: 8, border: "1px solid #dde5d7", borderRadius: 6, backgroundColor: "#fff" }}>
                                                        {/* Icon + label */}
                                                        <div style={{ flexShrink: 0, width: 170, display: "flex", alignItems: "center", gap: 8 }}>
                                                            <i className={`fas ${fn.icon}`} style={{ color: "#7F8F7B", fontSize: "1.1rem", width: 20, textAlign: "center" }} />
                                                            <span style={{ fontSize: "0.88rem", fontWeight: 500 }}>{fn.label}</span>
                                                        </div>
                                                        {/* Badges */}
                                                        <div style={{ flex: 1, display: "flex", flexWrap: "wrap", gap: 6 }}>
                                                            {plantsForFn.map(plant => (
                                                                <span key={plant.name} style={{ display: "inline-flex", alignItems: "center", gap: 4, backgroundColor: "#DDE5D7", color: "#2e3d2a", borderRadius: 12, padding: "3px 8px 3px 10px", fontSize: "0.8rem", fontWeight: 500 }}>
                                                                    {plant.name}
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => removePlant(guildPlants.indexOf(plant))}
                                                                        style={{ background: "none", border: "none", padding: 0, marginLeft: 2, cursor: "pointer", color: "#4a5e44", lineHeight: 1 }}
                                                                        title="Remove"
                                                                    >
                                                                        <i className="fas fa-times" style={{ fontSize: "0.7rem" }} />
                                                                    </button>
                                                                </span>
                                                            ))}
                                                        </div>
                                                        {/* Add button */}
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm"
                                                            style={{ flexShrink: 0, backgroundColor: "#fff", borderColor: "#7F8F7B", color: "#7F8F7B" }}
                                                            onClick={() => buildFunctionSearch(fn.key)}
                                                        >
                                                            <i className="fas fa-plus" style={{ marginRight: 4 }} />Add
                                                        </button>
                                                    </div>
                                                );
                                            })}
                                        </>
                                    );
                                })()}
                            </TabPane>
                            <TabPane tabId={3}>
                                {(() => {
                                    const layerDefs = [
                                        { key: "Canopy",       label: "Canopy",       icon: "fa-tree",        iconSet: "fas" },
                                        { key: "Subcanopy",    label: "Subcanopy",    icon: "fa-tree",        iconSet: "fas" },
                                        { key: "Shrub",        label: "Shrub",        icon: "fa-cloud",       iconSet: "fas" },
                                        { key: "Herbaceous",   label: "Herbaceous",   icon: "fa-feather",     iconSet: "fas" },
                                        { key: "Ground Cover", label: "Ground Cover", icon: "fa-seedling",    iconSet: "fas" },
                                        { key: "Root Crop",    label: "Root Crop",    icon: "fa-carrot",      iconSet: "fas" },
                                        { key: "Vining",       label: "Vining",       icon: "fa-code-branch", iconSet: "fas" },
                                    ];
                                    const layerMatch = (plant, key) => plant.foodForestLayer &&
                                        (Array.isArray(plant.foodForestLayer) ? plant.foodForestLayer.includes(key) : plant.foodForestLayer === key);
                                    const filledCount = layerDefs.filter(l =>
                                        guildPlants.some(p => layerMatch(p, l.key)) || (starPlayer && layerMatch(starPlayer, l.key))
                                    ).length;
                                    return (
                                        <>
                                            {starPlayer && (
                                                <div style={{ backgroundColor: "#212529", color: "#fff", borderRadius: "4px 4px 0 0", padding: "8px 14px", fontSize: "0.85rem", marginTop: 12 }}>
                                                    <i className="fas fa-star" style={{ color: "#FF9900", marginRight: 6 }} />
                                                    Star Player: <strong>{starPlayer.name}</strong>
                                                    {starPlayer.foodForestLayer && <span style={{ marginLeft: 10, opacity: 0.75 }}>({Array.isArray(starPlayer.foodForestLayer) ? starPlayer.foodForestLayer.join(", ") : starPlayer.foodForestLayer})</span>}
                                                </div>
                                            )}
                                            <div style={{ backgroundColor: "#DDE5D7", borderLeft: "4px solid #7F8F7B", borderRadius: starPlayer ? "0 0 4px 4px" : "4px", padding: "14px 18px", marginBottom: 20 }}>
                                                <div style={{ fontWeight: 600, fontSize: "1rem", marginBottom: 4, color: "#2e3d2a" }}>Design your layers</div>
                                                <div style={{ fontSize: "0.9rem", color: "#3d4a38", lineHeight: 1.5 }}>
                                                    Make sure your guild plants fill different layers so each can reach its full potential. Add plants to any layer that needs more coverage.
                                                </div>
                                            </div>
                                            <div style={{ backgroundColor: "#fff", border: "1px solid #dde5d7", borderRadius: 4, padding: "8px 14px", marginBottom: 12, display: "flex", alignItems: "center", gap: 12 }}>
                                                <div style={{ flex: 1, height: 6, backgroundColor: "#DDE5D7", borderRadius: 3 }}>
                                                    <div style={{ height: "100%", width: `${Math.round((filledCount / layerDefs.length) * 100)}%`, backgroundColor: filledCount >= 4 ? "#7F8F7B" : "#FF9900", borderRadius: 3, transition: "width 0.3s" }} />
                                                </div>
                                                <div style={{ fontSize: "0.8rem", color: "#6c757d", whiteSpace: "nowrap" }}>
                                                    {filledCount} of {layerDefs.length} layers covered
                                                </div>
                                            </div>
                                            {layerDefs.map(layer => {
                                                const plantsForLayer = guildPlants.filter(p => layerMatch(p, layer.key));
                                                const starInLayer = starPlayer && layerMatch(starPlayer, layer.key);
                                                return (
                                                    <div key={layer.key} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 12px", marginBottom: 8, border: "1px solid #dde5d7", borderRadius: 6, backgroundColor: "#fff" }}>
                                                        <div style={{ flexShrink: 0, width: 170, display: "flex", alignItems: "center", gap: 8 }}>
                                                            <i className={`${layer.iconSet} ${layer.icon}`} style={{ color: "#7F8F7B", fontSize: "1.1rem", width: 20, textAlign: "center" }} />
                                                            <span style={{ fontSize: "0.88rem", fontWeight: 500 }}>{layer.label}</span>
                                                        </div>
                                                        <div style={{ flex: 1, display: "flex", flexWrap: "wrap", gap: 6 }}>
                                                            {starInLayer && (
                                                                <span style={{ display: "inline-flex", alignItems: "center", gap: 4, backgroundColor: "#FF9900", color: "#fff", borderRadius: 12, padding: "3px 10px", fontSize: "0.8rem", fontWeight: 600 }}>
                                                                    <i className="fas fa-star" style={{ fontSize: "0.65rem" }} /> {starPlayer.name}
                                                                </span>
                                                            )}
                                                            {plantsForLayer.map(plant => (
                                                                <span key={plant.name} style={{ display: "inline-flex", alignItems: "center", gap: 4, backgroundColor: "#DDE5D7", color: "#2e3d2a", borderRadius: 12, padding: "3px 8px 3px 10px", fontSize: "0.8rem", fontWeight: 500 }}>
                                                                    {plant.name}
                                                                    <button type="button" onClick={() => removePlant(guildPlants.indexOf(plant))} style={{ background: "none", border: "none", padding: 0, marginLeft: 2, cursor: "pointer", color: "#4a5e44", lineHeight: 1 }} title="Remove">
                                                                        <i className="fas fa-times" style={{ fontSize: "0.7rem" }} />
                                                                    </button>
                                                                </span>
                                                            ))}
                                                        </div>
                                                        <button type="button" className="btn btn-sm" style={{ flexShrink: 0, backgroundColor: "#fff", borderColor: "#7F8F7B", color: "#7F8F7B" }} onClick={() => buildLayerSearch(layer.key)}>
                                                            <i className="fas fa-plus" style={{ marginRight: 4 }} />Add
                                                        </button>
                                                    </div>
                                                );
                                            })}
                                        </>
                                    );
                                })()}
                            </TabPane>
                            <TabPane tabId={4}>
                                {(() => {
                                    const allPlants = starPlayer ? [starPlayer, ...guildPlants] : [...guildPlants]
                                    const familyCounts = {}
                                    allPlants.forEach(p => {
                                        const fam = p.plant_family || "Unknown"
                                        familyCounts[fam] = (familyCounts[fam] || 0) + 1
                                    })
                                    const numFamilies = Object.keys(familyCounts).length
                                    const penalty = Object.values(familyCounts).reduce((sum, c) => sum + Math.max(0, c - 1), 0)
                                    const score = numFamilies - penalty

                                    const getRating = (s) => {
                                        if (s >= 5) return { label: "Great", color: "#7F8F7B", message: "Outstanding! Your guild draws from many plant families, making it highly resilient to pests and disease. A well-balanced guild like this mimics nature at its best." }
                                        if (s === 4) return { label: "Good", color: "#8FAA6F", message: "Well done! Your guild has strong ecological balance. One more diverse family would push this into excellent territory." }
                                        if (s === 3) return { label: "Ok", color: "#FF9900", message: "A decent start. Adding one or two plants from new families will meaningfully improve resilience and guild stability." }
                                        if (s === 2) return { label: "Fair", color: "#E07B39", message: "Your guild is functional but vulnerable. Try to spread plants across more families to reduce risk." }
                                        return { label: "Poor", color: "#C0392B", message: "Most of your plants share a family. If that family is hit by disease or pests, the whole guild suffers. Add plants from different families." }
                                    }
                                    const rating = getRating(score)

                                    return (
                                        <>
                                            {/* Description callout */}
                                            <div style={{ backgroundColor: "#DDE5D7", borderLeft: "4px solid #7F8F7B", borderRadius: "4px", padding: "14px 18px", marginBottom: 20, marginTop: 12 }}>
                                                <div style={{ fontWeight: 600, fontSize: "1rem", marginBottom: 4, color: "#2e3d2a" }}>Check Diversity</div>
                                                <div style={{ fontSize: "0.9rem", color: "#3d4a38", lineHeight: 1.5 }}>
                                                    Plants from different families reduce the risk of total guild failure — if one family is hit by disease or pests, the others survive. Aim for as many unique families as possible.
                                                </div>
                                            </div>

                                            {/* Score card */}
                                            <div style={{ display: "flex", alignItems: "center", gap: 20, padding: "16px 20px", marginBottom: 20, border: "1px solid #dde5d7", borderRadius: 6, backgroundColor: "#fff" }}>
                                                <div style={{ flexShrink: 0, width: 72, height: 72, borderRadius: "50%", border: `3px solid ${rating.color}`, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                                    <span style={{ fontSize: "1.9rem", fontWeight: 700, color: rating.color, lineHeight: 1 }}>{score}</span>
                                                    <span style={{ fontSize: "0.6rem", fontWeight: 600, color: rating.color, textTransform: "uppercase", letterSpacing: "0.05em" }}>{rating.label}</span>
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ fontWeight: 600, fontSize: "1rem", color: "#2e3d2a", marginBottom: 4 }}>{rating.label} Diversity</div>
                                                    <div style={{ fontSize: "0.88rem", color: "#4a5e44", lineHeight: 1.5 }}>{rating.message}</div>
                                                    <div style={{ fontSize: "0.78rem", color: "#6c757d", marginTop: 6 }}>
                                                        {numFamilies} unique {numFamilies === 1 ? "family" : "families"}
                                                        {penalty > 0 && <span> · <span style={{ color: "#E07B39" }}>−{penalty} penalty point{penalty > 1 ? "s" : ""} for repeated families</span></span>}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Family rows — half width */}
                                            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                                                {Object.entries(familyCounts).map(([family, count]) => {
                                                    const familyPlants = allPlants.filter(p => (p.plant_family || "Unknown") === family)
                                                    return (
                                                        <div key={family} style={{ width: "calc(50% - 4px)", border: "1px solid #dde5d7", borderRadius: 6, backgroundColor: "#fff", overflow: "hidden" }}>
                                                            {/* Family header */}
                                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "7px 12px", backgroundColor: "#f5f8f3", borderBottom: "1px solid #dde5d7" }}>
                                                                <span style={{ fontSize: "0.88rem", fontWeight: 600 }}>{family}</span>
                                                                {count > 1 && <span style={{ fontSize: "0.72rem", color: "#E07B39" }}>−{count - 1} pt{count > 2 ? "s" : ""}</span>}
                                                            </div>
                                                            {/* Plant rows */}
                                                            {familyPlants.map((p, i) => (
                                                                <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 12px", borderBottom: i < familyPlants.length - 1 ? "1px solid #f0f0f0" : "none" }}>
                                                                    <div style={{ flexShrink: 0, width: 80, height: 55, borderRadius: 4, overflow: "hidden", border: "1px solid #dde5d7", display: "flex", alignItems: "center" }}>
                                                                        <StorageImage
                                                                            alt={p.name}
                                                                            imgKey={p.cardIconKey ? p.cardIconKey : "card_icons/" + p.name.toLowerCase().replace(/ /g, "_").replace(/[(),]/g, "") + ".png"}
                                                                            accessLevel="guest"
                                                                            onStorageGetError={(e) => console.error(e)}
                                                                            style={{ width: "80px", height: "55px", objectFit: "none", objectPosition: "center", display: "block" }}
                                                                        />
                                                                    </div>
                                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                                        <div style={{ fontWeight: 600, fontSize: "0.88rem", marginBottom: 2, display: "flex", alignItems: "center", gap: 6 }}>
                                                                            {p.name}
                                                                            {starPlayer && p.name === starPlayer.name && (
                                                                                <span style={{ backgroundColor: "#FF9900", color: "#fff", borderRadius: 10, padding: "1px 6px", fontSize: "0.65rem", fontWeight: 600 }}>
                                                                                    <i className="fas fa-star" style={{ fontSize: "0.6rem", marginRight: 3 }} />Star
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                        <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                                                                            <span style={{ marginRight: 8 }}><b>Layer:</b> {Array.isArray(p.foodForestLayer) ? p.foodForestLayer.join(", ") : p.foodForestLayer}</span>
                                                                            <span style={{ marginRight: 8 }}><b>Zone:</b> {p.USDAMin}–{p.USDAMax}</span>
                                                                        </div>
                                                                        <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                                                                            <b>Functions:</b> {Array.isArray(p.guildFunction) ? p.guildFunction.join(", ") : p.guildFunction}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </>
                                    )
                                })()}
                            </TabPane>
                            <TabPane tabId={5}>
                                {/* Description callout */}
                                <div style={{ backgroundColor: "#DDE5D7", borderLeft: "4px solid #7F8F7B", borderRadius: "4px", padding: "14px 18px", marginBottom: 16, marginTop: 12 }}>
                                    <div style={{ fontWeight: 600, fontSize: "1rem", marginBottom: 4, color: "#2e3d2a" }}>Draw Your Guild</div>
                                    <div style={{ fontSize: "0.9rem", color: "#3d4a38", lineHeight: 1.5 }}>
                                        Arrange your plants in this top-down view. In <strong>Move</strong> mode, drag plants from the palette onto the canvas and reposition them. In <strong>Select</strong> mode, click a plant on the canvas to select and remove it.
                                    </div>
                                </div>

                                {/* Guild Name */}
                                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                                    <label style={{ fontWeight: 600, fontSize: "0.88rem", margin: 0, whiteSpace: "nowrap" }}>
                                        Guild Name <span style={{ color: "#C0392B" }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={guildName || ""}
                                        onChange={e => setGuildName(e.target.value)}
                                        style={{ width: 280, padding: "5px 10px", border: `1px solid ${errors.guildName ? "#C0392B" : "#ced4da"}`, borderRadius: 4, fontSize: "0.88rem" }}
                                        placeholder="Name your guild…"
                                    />
                                    {errors.guildName && <span style={{ color: "#C0392B", fontSize: "0.78rem" }}>{errors.guildName}</span>}
                                </div>

                                <Row>
                                    <Col md={9}>
                                        {/* Mode toggle */}
                                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
                                            <button type="button" className="btn btn-sm"
                                                style={{ backgroundColor: canvasMode === "move" ? "#FF9900" : "#fff", borderColor: canvasMode === "move" ? "#FF9900" : "#d1d5db", color: canvasMode === "move" ? "#fff" : "#212529" }}
                                                onClick={() => { setCanvasMode("move"); setSelectedImageId(null) }}>
                                                <i className="fas fa-arrows-alt" style={{ marginRight: 5 }} />Move
                                            </button>
                                            <button type="button" className="btn btn-sm"
                                                style={{ backgroundColor: canvasMode === "select" ? "#FF9900" : "#fff", borderColor: canvasMode === "select" ? "#FF9900" : "#d1d5db", color: canvasMode === "select" ? "#fff" : "#212529" }}
                                                onClick={() => setCanvasMode("select")}>
                                                <i className="fas fa-mouse-pointer" style={{ marginRight: 5 }} />Select
                                            </button>
                                            {canvasMode === "select" && selectedImageId && (
                                                <button type="button" className="btn btn-sm"
                                                    style={{ backgroundColor: "#fff", borderColor: "#C0392B", color: "#C0392B" }}
                                                    onClick={() => { setImages(prev => prev.filter(img => img.id !== selectedImageId)); setSelectedImageId(null) }}>
                                                    <i className="fas fa-trash-alt" style={{ marginRight: 5 }} />Delete
                                                </button>
                                            )}
                                            <div style={{ marginLeft: "auto" }}>
                                                <button type="button" className="btn btn-sm"
                                                    style={{ backgroundColor: showRefCircle ? "#7F8F7B" : "#fff", borderColor: showRefCircle ? "#7F8F7B" : "#d1d5db", color: showRefCircle ? "#fff" : "#212529" }}
                                                    onClick={() => setShowRefCircle(v => !v)}>
                                                    <i className="fas fa-circle-notch" style={{ marginRight: 5 }} />10 ft ref
                                                </button>
                                            </div>
                                        </div>

                                        {/* Canvas */}
                                        <div
                                            onDrop={(e) => {
                                                e.preventDefault()
                                                if (!stageRef.current || !dragUrl.current) return
                                                stageRef.current.setPointersPositions(e)
                                                const pointerPos = stageRef.current.getPointerPosition()
                                                if (!pointerPos) return
                                                const newImage = {
                                                    id: `img-${Date.now()}`,
                                                    x: pointerPos.x,
                                                    y: pointerPos.y,
                                                    src: dragUrl.current,
                                                    plant: dragUrl.plant,
                                                    plantScale: dragUrl.plantScale || 1,
                                                    color: dragUrl.color || CIRCLE_COLORS[0],
                                                }
                                                setImages(prev => [...prev, newImage])
                                            }}
                                            onDragOver={e => e.preventDefault()}
                                        >
                                            <Stage width={800} height={500} style={{ border: "1px solid #dde5d7", borderRadius: 4 }} ref={stageRef}>
                                                <Layer>
                                                    {showRefCircle && (
                                                        <Group x={400} y={250}>
                                                            <Circle
                                                                radius={150}
                                                                fill="rgba(127,143,123,0.07)"
                                                                stroke="#7F8F7B"
                                                                strokeWidth={1.5}
                                                                dash={[8, 6]}
                                                                listening={false}
                                                            />
                                                            <Circle radius={3} fill="#7F8F7B" listening={false} />
                                                            <Text
                                                                text="10 ft radius"
                                                                y={-166}
                                                                offsetX={45}
                                                                width={90}
                                                                align="center"
                                                                fontSize={11}
                                                                fill="#4a5e44"
                                                                fontStyle="italic"
                                                                listening={false}
                                                            />
                                                        </Group>
                                                    )}
                                                    {images.map(image => (
                                                        <PlantCircle
                                                            key={image.id}
                                                            x={image.x} y={image.y}
                                                            src={image.src}
                                                            plant={image.plant}
                                                            plantScale={image.plantScale || 1}
                                                            color={image.color || CIRCLE_COLORS[0]}
                                                            isSelected={selectedImageId === image.id}
                                                            draggable={canvasMode === "move"}
                                                            onSelect={() => { if (canvasMode === "select") setSelectedImageId(image.id) }}
                                                            onDragEnd={e => updateImagePosition(image.id, e.target.x(), e.target.y())}
                                                        />
                                                    ))}
                                                </Layer>
                                            </Stage>
                                        </div>
                                    </Col>

                                    <Col md={3}>
                                        <div style={{ fontSize: "0.82rem", fontWeight: 600, marginBottom: 4, color: "#2e3d2a" }}>Plant Palette</div>
                                        <div style={{ fontSize: "0.75rem", color: "#6c757d", marginBottom: 10 }}>
                                            {canvasMode === "move" ? "Drag plants onto the canvas" : "Switch to Move mode to add plants"}
                                        </div>
                                        <div style={{ height: 440, overflowY: "auto", overflowX: "hidden" }}>
                                            {[starPlayer, ...guildPlants].filter(Boolean).map((plant, pindex) => (
                                                <div
                                                    key={plant.name}
                                                    draggable={canvasMode === "move"}
                                                    onDragStart={async () => {
                                                        if (canvasMode !== "move") return
                                                        try {
                                                            const iconKey = plant.designerIconKey
                                                                ? plant.designerIconKey
                                                                : `planner_icons/planner_${plant.name.toLowerCase().replace(/[(),]/g, "").replace(/\s+/g, "_")}_icon.png`
                                                            const signedURL = await Storage.get(iconKey, { level: "public" })
                                                            dragUrl.current = signedURL
                                                            dragUrl.plant = plant.name
                                                            dragUrl.plantScale = plantScales[plant.size] || 1
                                                            dragUrl.color = CIRCLE_COLORS[pindex % CIRCLE_COLORS.length]
                                                        } catch (err) {
                                                            console.error("Error fetching icon:", err)
                                                        }
                                                    }}
                                                    style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", marginBottom: 6, border: "1px solid #dde5d7", borderRadius: 6, backgroundColor: "#fff", cursor: canvasMode === "move" ? "grab" : "default", userSelect: "none" }}
                                                >
                                                    <div style={{ flexShrink: 0, width: 60, height: 42, borderRadius: 4, overflow: "hidden", border: "1px solid #dde5d7", display: "flex", alignItems: "center" }}>
                                                        <StorageImage
                                                            alt={plant.name}
                                                            imgKey={plant.cardIconKey ? plant.cardIconKey : "card_icons/" + plant.name.toLowerCase().replace(/ /g, "_").replace(/[(),]/g, "") + ".png"}
                                                            accessLevel="guest"
                                                            onStorageGetError={e => console.error(e)}
                                                            style={{ width: "60px", height: "42px", objectFit: "none", objectPosition: "center", display: "block", pointerEvents: "none" }}
                                                        />
                                                    </div>
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        <div style={{ fontWeight: 600, fontSize: "0.82rem", display: "flex", alignItems: "center", gap: 4, marginBottom: 2 }}>
                                                            {pindex === 0 && <i className="fas fa-star" style={{ color: "#FF9900", fontSize: "0.65rem" }} />}
                                                            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{plant.name}</span>
                                                        </div>
                                                        <div style={{ fontSize: "0.72rem", color: "#6c757d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                            {Array.isArray(plant.foodForestLayer) ? plant.foodForestLayer.join(", ") : plant.foodForestLayer}
                                                        </div>
                                                        <div style={{ fontSize: "0.72rem", color: "#6c757d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                            {Array.isArray(plant.guildFunction) ? plant.guildFunction.slice(0, 2).join(", ") : plant.guildFunction}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </Col>
                                </Row>
                                <div style={{ textAlign: "center", marginTop: 16 }}>
                                    <button type="button" className="btn btn-sm" style={{ backgroundColor: "#FF9900", borderColor: "#FF9900", color: "#fff", minWidth: 120 }} onClick={finishGuild}>
                                        Save Guild
                                    </button>
                                </div>
                            </TabPane>
                    </TabContent>
                   <div style={{ display: "flex", justifyContent: "space-between", marginTop: 16 }}>
                      <div>
                        {activeTabProgress !== 1 && activeTabProgress !== 5 && (
                          <button type="button" className="btn btn-sm" style={{ backgroundColor: "#fff", borderColor: "#d1d5db", color: "#212529" }} onClick={() => toggleTabProgress(activeTabProgress - 1)}>
                            ← Previous
                          </button>
                        )}
                      </div>
                      <div>
                        {activeTabProgress !== 5 && (
                          <button type="button" className="btn btn-sm" style={{ backgroundColor: "#FF9900", borderColor: "#FF9900", color: "#fff" }} onClick={() => {
                            if (activeTabProgress === 1 && pendingStarPlayer) setStarPlayer(pendingStarPlayer);
                            toggleTabProgress(activeTabProgress + 1);
                          }}>
                            Next →
                          </button>
                        )}
                      </div>
                   </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>


<Modal isOpen={searchGuild} toggle={toggleSearch} size="lg">
    <ModalHeader toggle={toggleSearch}>
        {guildFunction || layer ? `Add plant — ${guildFunction || layer}` : "Add plant"}
    </ModalHeader>
    <ModalBody style={{ padding: "12px 16px" }}>
        {/* Context strip */}
        <div style={{ display: "flex", gap: 16, marginBottom: 12, fontSize: "0.82rem", color: "#6c757d", padding: "6px 10px", backgroundColor: "#f5f8f3", borderRadius: 4 }}>
            {climate && <span><b>Climate:</b> {climate}</span>}
            {zone && <span><b>Zone:</b> {zone}</span>}
            {!climate && !zone && <span>Showing all results</span>}
        </div>
        {/* Results */}
        <div style={{ height: 420, overflowY: "auto", overflowX: "hidden" }}>
            {userGuildResults.length === 0 && (
                <div style={{ textAlign: "center", color: "#6c757d", marginTop: 40 }}>
                    {searching ? "Searching…" : "No results found."}
                </div>
            )}
            {userGuildResults.map((plant) => (
                <div
                    key={plant.name}
                    onClick={() => { addGuildPlant(plant); toggleSearch(); }}
                    style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 12px", marginBottom: 8, cursor: "pointer", border: "1px solid #dde5d7", borderRadius: 6, backgroundColor: "#fff", transition: "background-color 0.15s" }}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f5f8f3"}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = "#fff"}
                >
                    <div style={{ flexShrink: 0, width: 160, height: 100, borderRadius: 4, overflow: "hidden", border: "1px solid #dde5d7", display: "flex", alignItems: "center" }}>
                        <StorageImage
                            alt={plant.name}
                            imgKey={plant.cardIconKey ? plant.cardIconKey : "card_icons/" + plant.name.toLowerCase().replace(" ","_").replace("(","").replace(")","").replace(",","_").replace(" ","_")+".png"}
                            accessLevel="guest"
                            onStorageGetError={(error) => console.error(error)}
                            style={{ width: "160px", height: "100px", objectFit: "none", objectPosition: "center", display: "block" }}
                        />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontWeight: 600, fontSize: "0.95rem", marginBottom: 2 }}>{plant.name}</div>
                        <div style={{ fontSize: "0.8rem", color: "#6c757d" }}>
                            <span style={{ marginRight: 12 }}><b>Layer:</b> {Array.isArray(plant.foodForestLayer) ? plant.foodForestLayer.join(", ") : plant.foodForestLayer}</span>
                            <span style={{ marginRight: 12 }}><b>Zone:</b> {plant.USDAMin}–{plant.USDAMax}</span>
                            <span><b>Climate:</b> {Array.isArray(plant.climate) ? plant.climate.join(", ") : plant.climate}</span>
                        </div>
                        <div style={{ fontSize: "0.8rem", color: "#6c757d", marginTop: 2 }}>
                            <b>Functions:</b> {Array.isArray(plant.guildFunction) ? plant.guildFunction.join(", ") : plant.guildFunction}
                        </div>
                    </div>
                    <div style={{ flexShrink: 0, width: 28, height: 28, borderRadius: "50%", border: "2px solid #7F8F7B", display: "flex", alignItems: "center", justifyContent: "center", color: "#7F8F7B" }}>
                        <i className="fas fa-plus" style={{ fontSize: "0.75rem" }} />
                    </div>
                </div>
            ))}
        </div>
    </ModalBody>
</Modal>


    </React.Fragment>
  )
}

const mapStateToProps = (state, ownProps) => {
  console.log("guildbuilder_dataload")
     const sortedPlants = state.designer.plants.sort((a, b) => (a.name > b.name) ? 1 : -1);
  return ({
  userareas: state.goals.areas,
  profile: state.Profile.user,
  plantData: state.designer.plants,
  guildResults: state.goals.plants.sort((a, b) => (a.name > b.name) ? 1 : -1),
  plantDataMap: sortedPlants.reduce((map, obj) => (map[obj.name] = obj, map), {}),
  customplants: state.goals.customplants,
  })
}


const mapDispatchToProps = dispatch => ({
  onGetProfile: (username) => dispatch (getProfile(username)),
  onGetPlantData: () => dispatch(getPlantData()),
  onSearchGuild: searchGuildParams => dispatch(searchGuild(searchGuildParams)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BuildGuild)


